import React, { useEffect, useState, useRef } from "react";
import { useTheme } from "../config/ThemeContext";

const LiberoSubDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  options = [],
  libero = {},
  mode,
}) => {
  const theme = useTheme();
  const [selectedId, setSelectedId] = useState(options[0]?.id || "");
  const cancelRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setSelectedId(options[0]?.id || "");
    setTimeout(() => cancelRef.current?.focus(), 50);
  }, [isOpen, options]);

  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className={`rounded-xl shadow-xl p-6 w-full max-w-sm z-50 ${theme.primary.lightBg} ${theme.primary.text}`}>
        <h2 className="text-lg font-semibold">
          Libero #{libero.shirtNumber} – {libero.shirtName}
        </h2>
        <p className="text-sm mb-2">
          {mode === "enter" ? "Select player leaving the court" : "Select player entering the court"}
        </p>
        <select
          className={`w-full border rounded-md px-3 py-2 ${theme.primary.border} ${theme.primary.focusRing} ${theme.primary.text}`}
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
        >
          {options.map((opt) => (
            <option key={opt.id} value={opt.id}>
              #{opt.number} – {opt.name}
            </option>
          ))}
        </select>

        <div className="mt-4 flex justify-end space-x-3">
          <button onClick={() => onConfirm(selectedId)} className={theme.buttons.primary}>
            Confirm
          </button>
          <button
            ref={cancelRef}
            onClick={onCancel}
            className={theme.buttons.secondary}
            autoFocus
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiberoSubDialog;
